import { SubjectReference } from "../../models";

export interface GetSubjectListResponse {
    total: number;
    subjects: SubjectReference[];
    variables: string[];
}
